// Estilos compartidos de los formularios de login y recuperación de contraseña

export const inputClass = (hasError) =>
  `block w-full h-11 px-3.5 border bg-white rounded-lg text-[15px] text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-4 ${hasError ? 'border-red-400 focus:border-red-500 focus:ring-red-100' : 'border-gray-300 focus:border-brand focus:ring-brand-soft'}`

export const labelClass = (hasError) =>
  `text-sm font-medium ${hasError ? 'text-red-700' : 'text-gray-700'}`

export const submitButtonClass =
  'flex items-center justify-center w-full h-11 px-5 text-[15px] font-semibold text-white bg-brand rounded-lg gap-x-2 transition-colors enabled:hover:bg-brand-dark disabled:opacity-40 focus:outline-none focus:ring-4 focus:ring-brand-soft'

export const linkClass =
  'text-sm font-semibold text-brand hover:text-brand-dark focus:outline-none focus:underline'

export const errorAlertClass =
  'rounded-lg border border-red-200 bg-red-50 px-3.5 py-2.5 text-sm text-red-700'

export const successAlertClass =
  'rounded-lg border border-emerald-200 bg-emerald-50 px-3.5 py-2.5 text-sm text-emerald-800'
